import { useEffect, useState } from 'react';

export function useNavbarScroll(delay = 0) {
  useEffect(() => {
    let cancelled = false;
    let frameId = 0;
    let startId = 0;
    let scrolled = null;

    const setup = () => {
      if (cancelled) return;

      const header = document.getElementById('site-header');
      if (!header) return;

      const update = () => {
        frameId = 0;
        const isScrolled = window.scrollY > 24;
        if (isScrolled === scrolled) return;
        scrolled = isScrolled;
        header.classList.toggle('in-header--scrolled', isScrolled);
      };

      const onScroll = () => {
        if (!frameId) frameId = requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });

      return () => {
        window.removeEventListener('scroll', onScroll);
        if (frameId) cancelAnimationFrame(frameId);
      };
    };

    let teardown = null;

    const timer = window.setTimeout(() => {
      startId = requestAnimationFrame(() => {
        teardown = setup();
      });
    }, delay);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      if (startId) cancelAnimationFrame(startId);
      teardown?.();
    };
  }, [delay]);
}

export function useCityDetection() {
  const [citySuffix, setCitySuffix] = useState(' em todo o Brasil');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cityFromUrl = params.get('cidade');

    if (cityFromUrl) {
      setCitySuffix(' em ' + cityFromUrl.replace(/-/g, ' '));
      return;
    }

    const controller = new AbortController();
    const timer = window.setTimeout(() => {
      fetch('https://ipapi.co/json/', { signal: controller.signal })
        .then((res) => res.json())
        .then((data) => {
          if (data.city) setCitySuffix(' em ' + data.city);
        })
        .catch(() => {});
    }, 4000);

    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, []);

  return citySuffix;
}
